// extracted by mini-css-extract-plugin
export default {"container":"styles_container__kw-Ru","smallText":"styles_smallText__2950e","vector":"styles_vector__amW6w"};